import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlarmsComponent } from './alarms.component';
import { AlarmsRoutingModule } from './alarms-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from '../shared';

@NgModule({
  imports: [
    CommonModule,
    AlarmsRoutingModule,
    FormsModule,
    TableModule,
    NgbModule,
    TranslateModule,
    ToastModule, SharedModule
  ],
  declarations: [AlarmsComponent]
})
export class AlarmsModule { }
